// The mark of a person's mention (a `user` reference chip): their picture, or
// their initial on their color, as on the old web ("people are avatars"): who
// it is reads at a glance, unlike the same person icon on every mention.
//
// The picture comes from the members of the workspace being shown (already
// read for the screen, one list for every chip); outside a workspace the
// initial is drawn.
import { useQuery } from "@tanstack/react-query";
import { Avatar, fileUrl, useApi, useMeApp } from "@trameria/ui-core";
import { useContext } from "react";
import { membersQuery } from "../workspace";
import { CurrentWorkspaceContext } from "../workspace/context";

export function MentionMark({ id, name }: { id: string; name: string }) {
  const slug = useContext(CurrentWorkspaceContext)?.slug ?? null;
  const { apiBase } = useMeApp();
  const members = useQuery({
    ...membersQuery(useApi(), slug ?? ""),
    enabled: slug !== null,
  });
  const fileId =
    members.data?.find((x) => x.userId === id)?.avatarFileId ?? null;
  return (
    // Not selectable: copying the text must not pick up the initial.
    <span className="mr-[3px] inline-flex select-none align-[-3px]">
      <Avatar
        // Seeded by the name, as the messages' and the lists' pictures are.
        name={name}
        image={fileId ? fileUrl(apiBase, fileId) : null}
        size={15}
      />
    </span>
  );
}
